<style scoped lang="scss">
.content-div {
  flex: 1;
}

.Agent-content-div {
  height: fit-content;
  background-color: rgb(242 242 242) !important;
}

.grade-list-div,
.lower_data-div,
.user-empower-div {
  background-color: white;
  width: fit-content;
  padding: 1rem;
}

.grade_table {
  width: fit-content;
  max-height: 20rem;
  height: fit-content;
  overflow: auto;
}

.lower_data {
  width: fit-content;
}

.user-empower-header {
  color: blue;
  font-weight: 550;
}

.user-empower-header:hover {
  cursor: pointer;
}

.show_uid-span {
  color: rgb(115, 115, 115);
  margin-top: 0.75rem !important;
  margin-bottom: 0.75rem !important;
}

.addEmpower-btn,
.addEmpower-str1,
.agentList-str1 {
  margin-left: 1.35rem;
  margin-bottom: 0.75rem;
}

.addEmpower-str1,
.agentList-str1,
.agentList-str2 {
  color: rgb(181, 181, 181);
}

.money_total_num {
  font-size: 2rem;
  color: red;
  margin-right: 0.5rem;
}

.pagination {
  margin: 1.5rem auto 0;
  width: fit-content;
}

.empower_data {
  width: fit-content;
  overflow: auto;
}

// 手机
@media screen and (max-width: 768px) {
  .Agent-content-div {
    min-width: fit-content;
  }

  .grade-list-div,
  .lower_data-div,
  .user-empower-div {
    background-color: white;
    margin-left: 1rem !important;
    margin-top: 1rem !important;
    width: fit-content;
    padding: 1rem;
  }
}

//pc
@media screen and (min-width: 769px) {

  .grade-list-div,
  .lower_data-div,
  .user-empower-div {
    margin-left: 2rem !important;
    margin-top: 2rem !important;
  }

  .lower_data-div {
    width: fit-content;
    min-width: 90%;
  }
}

.not-developer-praent {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

.not-developer-div {
  padding: 1rem;
  width: fit-content;
  background-color: white;
  border-radius: 5px;
}
</style>

<template>
  <div class="common-layout">
    <el-container>
      <el-aside style="width: fit-content;">
        <UserHead />
      </el-aside>
      <el-container>
        <el-header style="padding: 0;">
          <HeadTop />
        </el-header>
        <el-main
          style="padding-top: 0;padding-left: 0;  background-color: rgb(242 242 242) !important;height:100vh;overflow: auto;">
          <div class="Agent-content-div">
            <div v-if="isDeveloper == 0" class="not-developer-praent">
              <div class="not-developer-div">
                <p style="font-size: 1rem;">您还不是开发者，暂时无法查看本页面喔~</p>
                <div style="text-align: center; width: fit-content;margin: 3rem auto 0.5rem;font-size: 1rem;">
                  <el-button type="primary" @click="goApiUrl">
                    成为开发者
                  </el-button>
                </div>
              </div>
            </div>
            <div v-else style="margin-bottom: 3rem;">
              <el-tabs v-model="activeName" @tab-click="handleClick" class="lower_data-div  rounded shadow">
                <el-tab-pane label="授权列表" name="first">
                  <el-select v-model="select_includes" clearable placeholder="Select"
                    style="width: 240px;margin-left: 1rem;width: 8rem;" @change="getPluginAuth()">
                    <el-option label="全部插件" value="-1" />
                    <el-option v-for="item in deveploerData.list" :key="item.id" :label="item.name" :value="item.id" />
                  </el-select>
                  <el-input style="width:180px;margin-left: 10px;" v-model="PluginAuth.keyword"
                            placeholder="邮箱/授权字段关键词" width="200"/>
                  <el-button style="margin-left: 10px;" type="primary" @click="getPluginAuth()">搜索</el-button>
                  <div>
                    <el-table :data="PluginAuth.data" width="100%">
                      <el-table-column prop="userEmail" label="用户邮箱" />
                      <el-table-column prop="includesId" label="插件ID" />
                      <el-table-column prop="includeName" label="插件名称" />
                      <el-table-column prop="versionName" label="功能版本" />
                      <el-table-column prop="addUid" label="添加者UID" />
                      <el-table-column label="授权字段" width="180">
                        <template v-slot="scope">
                          <el-input v-model="scope.row.host"
                            @change="updatePluginAuth(scope.row.authId, 1, null, scope.row.host)"
                            placeholder="请输入域名/IP"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column prop="addDate" label="添加时间" />
                      <el-table-column prop="endDate" label="到期时间">
                        <template v-slot="scope">
                          <div class="liu-text-info" v-if="getEndDateColor(scope.row.endDate) == 1">{{
                            scope.row.endDate }}
                          </div>
                          <div class="liu-text-warning" v-else-if="getEndDateColor(scope.row.endDate) == 2">{{
                            scope.row.endDate
                          }}(即将到期)</div>
                          <div class="liu-text-danger" v-else>{{ scope.row.endDate }}(已到期)</div>
                        </template>
                      </el-table-column>
                      <el-table-column label="类型">
                        <template v-slot="scope">
                          <el-tag type="info" v-if="scope.row.isFree === 1">免费</el-tag>
                          <el-tag type="success" v-else>付费</el-tag>
                        </template>
                      </el-table-column>
                      <el-table-column label="状态">
                        <template v-slot="scope">
                          <el-tag type="success" v-if="scope.row.state === 1">正常</el-tag>
                          <el-tag type="danger" v-else>禁用</el-tag>
                        </template>
                      </el-table-column>
                      <el-table-column prop="banDesc" label="禁用原因">
                        <template v-slot="scope">
                          <div type="success" v-if="scope.row.state === 1">无</div>
                          <div type="success" v-else>{{ scope.row.banDesc }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column label="操作" width="150">
                        <template v-slot="scope">
                          <div style="display: flex;flex-direction: row;">
                            <el-button type="warning" v-if="scope.row.state === 1"
                              @click="banAuthDialog(scope.row.authId)">禁用</el-button>
                            <el-button type="success" v-else @click="openAuthDialog(scope.row.authId)">开启</el-button>
                            <el-button type="danger"
                              v-if="getEndDateColor(scope.row.endDate) === 3 || scope.row.isFree == 1"
                              @click="deletePluginAuthDialog(scope.row.authId)">删除</el-button>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                    <el-pagination class="pagination" v-model:current-page="PluginAuth.currentPage"
                      v-model:page-size="PluginAuth.pageSize" :page-sizes="[10, 25, 50]"
                      layout="total, sizes, prev, pager, next, jumper" :total="PluginAuth.total"
                      @size-change="getPluginAuth" @current-change="getPluginAuth" />
                  </div>

                </el-tab-pane>
                <el-tab-pane label="代理列表" name="second">
                  <el-select v-model="pluginAgent.pluginId" clearable placeholder="Select"
                    style="width: 240px;margin-left: 1rem;width: 8rem;" @change="getMyPluginsAgent()">
                    <el-option label="全部插件" value="-1" />
                    <el-option v-for="item in deveploerData.list" :key="item.id" :label="item.name" :value="item.id" />
                  </el-select>
                  <el-input style="width:180px;margin-left: 10px;" v-model="pluginAgent.keyword"
                            placeholder="邮箱/uid关键词" width="200"/>
                  <el-button style="margin-left: 10px;" type="primary" @click="getMyPluginsAgent()">搜索</el-button>
                  <div>
                    <el-table :data="pluginAgent.data" width="100%">
                      <el-table-column prop="user_email" label="用户邮箱" />
                      <el-table-column prop="uid" label="UID" />
                      <el-table-column prop="includes_id" label="插件ID" />
                      <el-table-column prop="include_name" label="插件名称" />
                      <el-table-column prop="grade_name" label="代理名称" />
                      <el-table-column label="状态">
                        <template v-slot="scope">
                          <el-tag type="success" v-if="scope.row.state === 1">正常</el-tag>
                          <el-tag type="danger" v-else>禁用</el-tag>
                        </template>
                      </el-table-column>
                      <el-table-column prop="banDesc" label="禁用原因">
                        <template v-slot="scope">
                          <div type="success" v-if="scope.row.state === 1">无</div>
                          <div type="success" v-else>{{ scope.row.ban_desc }}</div>
                        </template>
                      </el-table-column>
                      <el-table-column label="操作" width="150">
                        <template v-slot="scope">
                          <div style="display: flex;flex-direction: row;">
                            <el-button type="warning" v-if="scope.row.state === 1"
                              @click="banAgentDialog(scope.row.id)">禁用</el-button>
                            <el-button type="success" v-else @click="openAgentDialog(scope.row.id)">开启</el-button>
                          </div>
                        </template>
                      </el-table-column>
                    </el-table>
                    <el-pagination class="pagination" v-model:current-page="pluginAgent.currentPage"
                      v-model:page-size="pluginAgent.pageSize" :page-sizes="[10, 25, 50]"
                      layout="total, sizes, prev, pager, next, jumper" :total="pluginAgent.total"
                      @size-change="getMyPluginsAgent" @current-change="getMyPluginsAgent" />
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
        </el-main>
      </el-container>
    </el-container>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import UserHead from '@/components/UserHead.vue';
import HeadTop from '@/components/UserHeadTop.vue';
import { isNull, openBox } from "@/utils/publicMethods"
import { ElMessage } from 'element-plus'
import { openLoading, fullscreenLoading } from '@/utils/loadingUtils'
import axios from 'axios';
const baseURL = process.env.VUE_APP_API_BASE_URL;
export default defineComponent({
  components: {
    UserHead,
    HeadTop
  },
  computed: {
  },
  watch: {
    activeName: function (val) {
      if (val == 'second') {
        this.getMyPluginsAgent();
      }else if (val == 'first') {
        this.getPluginAuth();
      }
    },
  },
  data() {
    return {
      activeName: "first",
      PluginAuth: {
        total: 0,
        pageSize: 10,
        currentPage: 1,
        data: [],
        keyword: "",
        pluginId: null,
      },
      pluginAgent:{
        total: 0,
        pageSize: 10,
        currentPage: 1,
        data: [],
        keyword: "",
        pluginId: "全部插件"
      },
      select_includes: "全部插件",
      deveploerData: {},
      isDeveloper: 0
    }
  },
  methods: {
    getInfo() {
      openLoading()
      const headers = {
        'token': localStorage.getItem("token")
      }
      axios.get(baseURL + '/dev/getInfo', { timeout: 5000, headers })
        .then(res => {
          if (res.data.code == 200) {
            this.isDeveloper = 1;
            this.deveploerData = res.data.data
          } else if (res.data.code == 403) {
            this.isDeveloper = 0;
            this.deveploerConf.apiUrl = res.data.data;
            openBox(res.data.data)
          }
          else {
            ElMessage.error(res.data.msg)
          }
          if (res.data.code == 401) {
            setTimeout(() => {
              location.href = "/Login"
            }, 1000);

          }
        }).catch(err => {
          ElMessage.error(err)
        }).finally(() => {
          fullscreenLoading.close()
        })
    },
    getMyPluginsAgent() {
      openLoading()
      const headers = {
        'token': localStorage.getItem("token")
      }
      axios.post(baseURL + "/dev/getMyPluginsAgent", {
        pluginId: this.pluginAgent.pluginId == "全部插件" || this.pluginAgent.pluginId  == -1 ? null : this.pluginAgent.pluginId ,
        pageSize: this.pluginAgent.pageSize,
        currentPage: this.pluginAgent.currentPage,
        keyword: this.pluginAgent.keyword
      }, { timeout: 5000, headers: headers })
        .then(res1 => {
          fullscreenLoading.close()
          if (res1.data.code == 401) {
            ElMessage.error(res1.data.msg)
            setTimeout(() => {
              location.href = "/Login"
            }, 1000);
            return
          }
          else if (res1.data.code == 200) {
            this.pluginAgent.data  = res1.data.data.data;
            this.pluginAgent.total = res1.data.data.count;
          }
          else {
            ElMessage.error(res1.data.msg)
          }
        })
        .catch(err => {
          fullscreenLoading.close()
          console.log(err)
          ElMessage.error('获取代理用户失败' + err.message)
        })
    },
    getPluginAuth() {
      openLoading()
      const headers = {
        'token': localStorage.getItem("token")
      }
      axios.post(baseURL + "/dev/getMyPluginAuth", {
        pluginId: this.select_includes == "全部插件" || this.select_includes == -1 ? null : this.select_includes,
        pageSize: this.PluginAuth.pageSize,
        currentPage: this.PluginAuth.currentPage,
        keyword: this.PluginAuth.keyword
      }, { timeout: 5000, headers: headers })
        .then(res1 => {
          fullscreenLoading.close()
          if (res1.data.code == 401) {
            ElMessage.error(res1.data.msg)
            setTimeout(() => {
              location.href = "/Login"
            }, 1000);
            return
          }
          else if (res1.data.code == 200) {
            this.PluginAuth.data = res1.data.data.data;
            this.PluginAuth.total = res1.data.data.total;
          }
          else {
            ElMessage.error(res1.data.msg)
          }
        })
        .catch(err => {
          fullscreenLoading.close()
          console.log(err)
          ElMessage.error('获取授权失败' + err.message)
        })
    },
    deletePluginAuthDialog(authId) {
      this.$confirm('此操作将永久删除该授权, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const headers = {
          'token': localStorage.getItem("token")
        }
        axios.get(baseURL + `/dev/deleteAuthById?authId=${authId}`, { timeout: 5000, headers: headers })
          .then(res1 => {
            fullscreenLoading.close()
            if (res1.data.code == 401) {
              ElMessage.error(res1.data.msg)
              setTimeout(() => {
                location.href = "/Login"
              }, 1000);
              return
            }
            else if (res1.data.code == 200) {
              ElMessage.success(res1.data.msg)
              this.getPluginAuth()
            }
            else {
              ElMessage.error(res1.data.msg)
            }
          })
          .catch(err => {
            fullscreenLoading.close()
            console.log(err)
            ElMessage.error('获取等级信息失败：' + err.message)
          })
      }).catch((e) => {
        console.log(e);

      })
    },
    updatePluginAuth(authId, status, banDesc, host) {
      const data = {
        status: status,
        banDesc: banDesc,
        host: host
      };
      axios.post(baseURL + "/dev/updatePluginAuth?authId=" + authId,
        data, {
        timeout: 5000,
        headers: {
          'token': localStorage.getItem("token")
        }
      }).then(res => {
        if (res.data.code == 200) {
          ElMessage.success(res.data.msg)
          this.getPluginAuth();
        }
        else {
          ElMessage.error(res.data.msg)
        }
      })
    },
    updatePluginAgent(id, status, banDesc, grade) {
      const data = {
        state: status,
        banDesc: banDesc,
        grade: grade
      };
      axios.post(baseURL + "/dev/updatePluginAgent?id=" + id,
        data, {
        timeout: 5000,
        headers: {
          'token': localStorage.getItem("token")
        }
      }).then(res => {
        if (res.data.code == 200) {
          ElMessage.success(res.data.msg)
          this.getMyPluginsAgent();
        }
        else {
          ElMessage.error(res.data.msg)
        }
      })
    },
    banAgentDialog(id) {
      this.$prompt('请输入禁用原因', '提示', {
        confirmButtonText: '禁用',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        this.updatePluginAgent(id, 2, value, null);
      }).catch((e) => {
        console.log(e);
      })
    },
    openAgentDialog(id) {
      this.updatePluginAgent(id, 1, null, null)
    },
    banAuthDialog(authId) {
      this.$prompt('请输入禁用原因', '提示', {
        confirmButtonText: '禁用',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        this.updatePluginAuth(authId, 2, value, null);
      }).catch((e) => {
        console.log(e);
      })
    },
    openAuthDialog(authId) {
      this.updatePluginAuth(authId, 1, null, null)
    },
    deleteAuthDialog(empower_id) {
      this.deleteAuth_id = empower_id
      this.openDialog('消息', '您确定要删除此授权吗？此操作不可撤销', true, 'deleteAuth')
    },
    getEmpowerIncludesList() {
      openLoading()
      const headers = {
        'token': localStorage.getItem("token")
      }
      var data = new FormData()
      data.append("act", 'getEmpowerIncludesList')
      axios.post(baseURL + "/userApi/getIncludesAgent", data, { timeout: 5000, headers: headers })
        .then(res => {
          fullscreenLoading.close()
          if (res.data.code == 401) {
            ElMessage.error(res.data.msg)
            setTimeout(() => {
              location.href = "/Login"
            }, 1000);
            return
          }
          else if (res.data.code == 200) {
            this.includes_data.includes_list = res.data.data;
          }
          else {
            ElMessage.error(res.data.msg)
          }
        })
        .catch(err => {
          fullscreenLoading.close()
          console.log(err)
          ElMessage.error('获取代理插件列表失败：' + err.message)
        })
    },
    getEndDateColor(end_date) {
      var endDate = new Date(end_date);
      if (endDate.getTime() < new Date().getTime()) {
        //已过期
        return 3;
      }
      if (endDate.getTime() < new Date().getTime() + 1000 * 60 * 60 * 24 * 3) {
        //即将过期
        return 2;
      }
      return 1;
    }
  },
  mounted() {
    window.ResizeObserver = this.$customResizeObserver
    this.getPluginAuth();
    this.getInfo();
  }
})
</script>
